function injectStyle (ssrContext) {
  require("!!../../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-fdeb4b38\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Zoom.vue")
}
var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Zoom.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-fdeb4b38\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Zoom.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fdeb4b38",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/tool/batch/exportOrderCsv/filters/marketplace/Zoom.vue
// module id = 2609
// module chunks = 0